import React from "react";

function ProductsHome() {
  return (
    <div>
      <>
        {/* Start Featured Product */}
        <section className="bg-light">
          <div className="container py-5">
            <div className="row text-center py-3">
              <div className="col-lg-6 m-auto wow animate__animated animate__fadeInDown animate__slow">
                <h1 className="h1 text-success">Featured Product</h1>
                <p>
                  Reprehenderit in voluptate velit esse cillum dolore eu fugiat
                  nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4 mb-4 wow animate__animated animate__fadeInUp animate__slow rounded-5">
                <div className="card h-100">
                  <img
                    src="./assets/img/feature_prod_01.jpg"
                    className="card-img-top"
                    alt="..."
                  />

                  <div className="card-body">
                    <ul className="list-unstyled d-flex justify-content-between">
                      <li>
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-muted fa fa-star" />
                        <i className="text-muted fa fa-star" />
                      </li>
                      <li className="text-muted text-right">$240.00</li>
                    </ul>
                    <h3 className="h3 text-dark">Gym Weight</h3>
                    <p className="card-text">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Sunt in culpa qui officia deserunt.
                    </p>
                    <p className="text-muted">Reviews (24)</p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4 mb-4 wow animate__animated animate__fadeInUp animate__slow animate__delay-1s rounded-5">
                <div className="card h-100">
                  <img
                    src="./assets/img/feature_prod_02.jpg"
                    className="card-img-top"
                    alt="..."
                  />
                  <div className="card-body">
                    <ul className="list-unstyled d-flex justify-content-between">
                      <li>
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-muted fa fa-star" />
                        <i className="text-muted fa fa-star" />
                      </li>
                      <li className="text-muted text-right">$480.00</li>
                    </ul>
                    <h3 className="h3 text-dark">Cloud Nike Shoes</h3>
                    <p className="card-text">
                      Aenean gravida dignissim finibus. Nullam ipsum diam,
                      posuere vitae pharetra sed, commodo ullamcorper.
                    </p>
                    <p className="text-muted">Reviews (48)</p>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-4 mb-4 wow animate__animated animate__fadeInUp animate__slower animate__delay-1s rounded-5">
                <div className="card h-100">
                  <img
                    src="./assets/img/feature_prod_03.jpg"
                    className="card-img-top"
                    alt="..."
                  />

                  <div className="card-body">
                    <ul className="list-unstyled d-flex justify-content-between">
                      <li>
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                        <i className="text-warning fa fa-star" />
                      </li>
                      <li className="text-muted text-right">$360.00</li>
                    </ul>
                    <h3 className="h3 text-dark">Summer Addides Shoes</h3>
                    <p className="card-text">
                      Curabitur ac mi sit amet diam luctus porta. Phasellus
                      pulvinar sagittis diam, et scelerisque ipsum lobortis nec.
                    </p>
                    <p className="text-muted">Reviews (74)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Featured Product --
         */}
      </>
    </div>
  );
}

export default ProductsHome;
